<template>
  <Card :btnMsg="$t('ensureEmail.btn_text')" @changeStep="changeStep">
    <div class="card-ensureEmail">
      <div class="card-content">
        <p class="card-title" v-html="$t('ensureEmail.title')"></p>
        <div class="card-text" v-html="$t('ensureEmail.text')"></div>
        <div class="gift-card-input">
          <a-form-model ref="formBasic" :model="form" :rules="formRules">
            <a-form-model-item label="" prop="email">
              <a-input v-model="form.email" size="large" type="primary" :placeholder="$t('ensureEmail.email_placeholder')"></a-input>
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="gift-card-box">
          <div class="gift-card-box-pic">
            <img :src="form.channel_pic" />
          </div>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/card.vue';
import { postSubmit } from '@/api/portal';

export default {
  components: {
    Card,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      formRules: {
        name: [{ required: true, message: this.$t('formBasic.form_name_placeholder'), trigger: 'blur' }],
        email: [
          { required: true, message: this.$t('formBasic.form_email_placeholder'), trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: this.$t('formBasic.form_email_error_placeholder'),
            trigger: 'change',
          },
        ],
        order_id: [
          { required: true, message: this.$t('formBasic.form_order_placeholder'), trigger: 'blur' },
          {
            pattern: /^\d{3}-\d{7}-\d{7}$/,
            message: this.$t('formBasic.form_order_error_placeholder'),
            trigger: 'change',
          },
          {
            pattern: /^\d{3}-\d{7}-\d{7}$/,
            message: this.$t('formBasic.form_order_error_placeholder'),
            trigger: 'blur',
          },
        ],
      },
      // giftCard: require('@/assets/gift-card.png'),
    };
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    checkForm() {
      let bol = false;
      this.$refs.formBasic.validate(valid => {
        if (valid) {
          bol = true;
          return true;
        } else {
          bol = false;
          return false;
        }
      });
      this.$nextTick(_ => {});
      return bol;
    },
    changeStep() {
      let bol = this.checkForm();
      if (bol) {
        postSubmit(this.form).then(res => {
          this.$emit('input', this.form);
          let len = this.form.questions.length;
          let starEnd = this.form.questions[len - 1];
          if (starEnd.star > 3) {
            this.$parent.changeStep('thanksAll',this.form);
          } else {
            this.$parent.changeStep('thanks',this.form);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.card-ensureEmail {
  position: relative;
  width: 100%;
  .card-title {
    font-size: 24px;
    font-weight: 500;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .card-text {
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 20px;
  }
  .gift-card-input {
    font-size: 17px;
    font-weight: 400;
    color: #1a1a1a;
    margin-bottom: 40px;
    .ant-input {
      font-size: 17px;
    }
  }
  .gift-card-box-pic {
    img {
      width: 100%;
    }
  }
  .gift-card-box {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: linear-gradient(180deg, #ffd814aa, #ffa031aa);
    border-radius: 10px;
    border: 2px solid #ffd814aa;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    .gift-card-box-text {
      font-size: 22px;
      font-weight: 500;
      text-align: center;
    }
  }
  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
}
</style>
